import { render, staticRenderFns } from "./Evenements.vue?vue&type=template&id=6a0a5d85&scoped=true"
import script from "./Evenements.vue?vue&type=script&lang=js"
export * from "./Evenements.vue?vue&type=script&lang=js"
import style0 from "./Evenements.vue?vue&type=style&index=0&id=6a0a5d85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a5d85",
  null
  
)

export default component.exports